import { render, staticRenderFns } from "./ConfigMonitor.vue?vue&type=template&id=bf2968aa&"
import script from "./ConfigMonitor.vue?vue&type=script&lang=js&"
export * from "./ConfigMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMonitor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports